/* eslint-disable quote-props */
import { CSSObject, Theme, styled } from "@mui/material";

import { DRAWER_WIDTH } from "../../config/params";
import MuiDrawer from "@mui/material/Drawer";

export const Logo = styled("div")(({ theme }) => ({
  paddingTop: "32px",
  paddingBottom: "32px",
  paddingLeft: "26px",
  [theme.breakpoints.down(1100)]: {
    paddingTop: "56px",
    paddingBottom: "44px",
    paddingLeft: "11px",
  },
}));

const openedMixin = (theme: Theme): CSSObject => ({
  width: DRAWER_WIDTH,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
  top: "0",
});

const closedMixin = (theme: Theme): CSSObject => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
  top: "0",
});

export const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
}));

export const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== "open" })(
  ({ theme, open }) => ({
    width: DRAWER_WIDTH,
    flexShrink: 0,
    whiteSpace: "nowrap",
    boxSizing: "border-box",
    ".active": {
      position: "relative",
    },
    ".MuiDrawer-paper": {
      backgroundColor: "#FFFFFF",
    },
    "& .MuiListItemButton-root": {
      padding: "0 24px",
    },
    "& .MuiBox-root": {
      "p, b": {
        fontFamily: "geograph-regular",
      },
      "p": {
        fontSize: "12px",
      },
      "b": {
        fontSize: "16px",
      },
    },
    "& .MuiTypography-root": {
      fontFamily: "geograph-regular",
      fontSize: "18px",
      color: "#262626",
    },
    ...(open && {
      ...openedMixin(theme),
      "& .MuiDrawer-paper": openedMixin(theme),
    }),
    ...(!open && {
      ...closedMixin(theme),
      "& .MuiDrawer-paper": closedMixin(theme),
    }),
  }),
);
